import aboutImg from "../about-graphic.svg";
export const AboutIcon = () => {
  //   const { width, height, color } = props;
  return (
    <img src={aboutImg} className="text-center mx-auto" alt="About platform" />
  );
};
